// Canonical Shadow brand mark (v1.1): a voice wave held apart from a pair of
// graph nodes joined by an edge. The gap between wave and nodes is part of the
// mark — never close it. Light: ink + #9A9A9A. Dark: white + 50% white.

export function ShadowMark({ size = 26, color = "#0E0E0C", secondary = "#9A9A9A" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
      <path
        d="M4 27 C7 16, 11.5 16, 14.5 25 C17 32.5, 20 32.5, 22 26"
        fill="none" stroke={color} strokeWidth="4.4" strokeLinecap="round"
      />
      <line x1="32" y1="17" x2="41" y2="29" stroke={secondary} strokeWidth="2.6" strokeLinecap="round" />
      <circle cx="32" cy="17" r="5" fill={color} />
      <circle cx="41" cy="29" r="4" fill={secondary} />
    </svg>
  );
}

// The "peeker" mascot that pokes over the footer divider.
export function Peeker({ className = "fpeeker", style }) {
  return (
    <svg className={className} style={style} viewBox="0 0 110 46" aria-hidden="true">
      <path d="M30 46 C 30 22, 38 11, 55 11 C 72 11, 80 22, 80 46 Z" fill="#0E0E0C" />
      <ellipse cx="47" cy="30" rx="4" ry="5.5" fill="#FFFFFF" />
      <ellipse cx="63" cy="30" rx="4" ry="5.5" fill="#FFFFFF" />
      <circle cx="33" cy="44" r="4.5" fill="#0E0E0C" />
      <circle cx="77" cy="44" r="4.5" fill="#0E0E0C" />
    </svg>
  );
}

// The small peeker that sits above an inline Shadow suggestion chip (44x16 viewBox).
export function PeekChip({ width = 34, height = 13 }) {
  return (
    <span className="peek" aria-hidden="true">
      <svg viewBox="0 0 44 16" width={width} height={height}>
        <path d="M8 16 C 8 6, 13 1, 22 1 C 31 1, 36 6, 36 16 Z" fill="#0E0E0C" />
        <ellipse cx="17.5" cy="9" rx="2.4" ry="3" fill="#FFFFFF" />
        <ellipse cx="26.5" cy="9" rx="2.4" ry="3" fill="#FFFFFF" />
      </svg>
    </span>
  );
}
